// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"173":"35f80088c96575b3cc63","468":"cd9a885350b374b698f8"}[chunkId] + ".js";
};